import React from 'react';
import { Icon } from 'view/atoms';
import { ReactComponent as LinkIcon } from 'static/icons/resizable/link.svg';
import { companyLink } from 'static/icons/resizable';
import * as S from './Link.styles';

type LinkProps = {
  children: React.ReactNode;
  href?: string;
  color?: string;
  withIcon?: boolean;
  onClick?: React.MouseEventHandler;
  onTouchStart?: React.TouchEventHandler;
  withAlternativeIcon?: boolean;
  'data-testid'?: string;
};

export const Link = ({
  withIcon = false,
  href,
  children,
  color,
  onClick,
  onTouchStart,
  withAlternativeIcon,
  'data-testid': dataTestId,
}: LinkProps) => {
  return (
    <S.LinkWrapStyled onClick={onClick} onTouchStart={onTouchStart} data-testid={dataTestId}>
      {withIcon && color && <LinkIcon stroke={color} />}
      {withAlternativeIcon && <Icon src={companyLink} />}
      <S.LinkStyled
        withIcon={withIcon}
        href={href}
        color={color}
        withAlternativeIcon={withAlternativeIcon}
        target='_blank'
      >
        {children}
      </S.LinkStyled>
    </S.LinkWrapStyled>
  );
};
